export interface ISorting {
  database: string;
  text: string;
}

export const sorting: ISorting[] = [{ database: "DESC", text: "Descending" }, { database: "ASC", text: "Ascending" }];
